import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'

import { CardEmpty } from 'containers/TextAnalysis/Content/CardEmpty'

export interface SentimentStateProps {
  pending: boolean
  done: boolean
  error: string
  data: { [key: string]: number }
}

export interface Props {
  title?: string
  sentiment: SentimentStateProps
}

interface SentimentDetails {
  color: string
  order: number
}

export const SENTIMENT_COLORS: Record<string, SentimentDetails> = {
  Positive: {
    color: '#2E7D32',
    order: 1,
  },
  Neutral: {
    color: '#FEE08B',
    order: 2,
  },
  Mixed: {
    color: '#FF9800',
    order: 3,
  },
  Negative: {
    color: '#D32F2E',
    order: 4,
  },
}

export const renderSentimentSkeletons = () => {
  return (
    <Box
      aria-label="Loading sentiment data"
      role="region"
      display="flex"
      flexDirection="column"
    >
      {Array.from({ length: 4 }, (_, index) => (
        <Box
          key={index}
          display="flex"
          alignItems="center"
          width="100%"
          maxWidth="570px"
        >
          <Skeleton variant="text" width="15%" height={26} />
          <Skeleton variant="text" width="4%" height={26} sx={{ ml: 1 }} />
          <Skeleton variant="text" width="72%" height={8} sx={{ ml: 2 }} />
          <Skeleton variant="text" width="6%" sx={{ ml: 2 }} />
        </Box>
      ))}
    </Box>
  )
}

export const renderEmptyState = (status?: string) => (
  <Box
    position="relative"
    height="9rem"
    data-testid="sentiment-summary-empty"
    tabIndex={0}
    width="100%"
    aria-label="No sentiment data available"
  >
    <CardEmpty sourceStatus={status} />
  </Box>
)
